import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Box, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';

const CommonDateTimePicker = ({
  ele,
  register,
  selectValues,
  handleDisable,
  errors,
  propsData,
  minDate,
  setValue,
  clearErrors,
  formError,
  edit,
  formValues,
}) => {

  useEffect(() => {
    // For endDateTime field in extension mode, don't auto-set the value
    // Let the pre-filled value from extensionDefaultValues take effect
    if(!edit && ele?.name !== 'endDateTime'){
      setValue(ele?.name, dayjs(minDate ? minDate : new Date()))
    }
  }, [minDate])

  // For endDateTime field, use scheduledTime as the minimum date
  // In extension mode, disable dates up to and including the current saved end date
  const getMinDateTime = () => {
    if (ele?.name === 'endDateTime') {
      // In extension mode, use the current saved end date + 1 day as minimum
      // This prevents extending to dates before or equal to the current end date
      if (propsData?.extensionMode && selectValues[ele?.name]) {
        // Add 1 day to the current end date to disable it and allow only future dates
        const currentEndDate = dayjs(selectValues[ele?.name]);
        return currentEndDate.add(1, 'day').startOf('day');
      }
      // During new booking, use scheduledTime as minimum
      if (formValues?.scheduledTime) {
        return dayjs(formValues?.scheduledTime);
      }
    }
    return dayjs(minDate);
  };

  const [openDateTimePicker, setOpenDateTimePicker] = useState(false);

  return (
    <Box className="customDatepicker">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="dateTimePickerContainer">
        <DateTimePicker
        open={openDateTimePicker}
        onOpen={() => setOpenDateTimePicker(true)}
       onClose={() => setOpenDateTimePicker(false)}
          {...register(ele?.name, {
            required: ele?.required,
            validate: (value) => {
              // Call the custom validation from field definition if it exists
              if (ele?.validation?.validate) {
                return ele?.validation?.validate(value, formValues);
              }
              return true;
            },
          })}
          format="DD/MM/YYYY HH:mm"
          placeholderText="Please select a date"
          defaultValue={
            selectValues[ele?.name] && dayjs(selectValues[ele?.name])
          }
          disabled={handleDisable(ele?.fieldDisabled, propsData?.disabled, ele?.name)}
          value={selectValues[ele?.name] ? dayjs(selectValues[ele?.name]) : ele?.name === 'endDateTime' && minDate && !edit ? dayjs(minDate) : dayjs(new Date())}
          minDateTime={getMinDateTime()}
          minutesStep={2}
          className="customDatepicker"
          onChange={(newDate) => {
            clearErrors(ele?.name);
            setValue(ele?.name, newDate);
          }}
          ampm={false}
          skipDisabled={true}
          renderInput={(params) => (
            <TextField
              {...params}
              error={errors[ele?.name] || formError[ele?.name]}
              inputProps={{
                ...params.inputProps,
              }}
              label="Select Date"
              placeholder="MM/DD/YYYY"
              fullWidth
              required
            />
          )}
        />
        <div
         className="clickableOverlay"
         onClick={() => setOpenDateTimePicker(true)}
         ></div>
        </div>
      </LocalizationProvider>
    </Box>
  );
};

export default CommonDateTimePicker;
